export default function Menu(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          maxWidth: 'calc(100vw - 24px) !important',
          backdropFilter: 'blur(48px) saturate(250%)',
          WebkitBackdropFilter: 'blur(48px) saturate(250%)', // Safari support
          border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.4)'}`,
          boxShadow: isDark 
            ? '0 8px 32px 0 rgba(0, 0, 0, 0.5)' 
            : '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          maxWidth: 'calc(100vw - 24px) !important',
          backdropFilter: 'blur(48px) saturate(250%)',
          WebkitBackdropFilter: 'blur(48px) saturate(250%)', // Safari support
          border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.4)'}`,
          boxShadow: isDark 
            ? '0 8px 32px 0 rgba(0, 0, 0, 0.5)' 
            : '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        }
      }
    }
  };
}
